import { Box } from '@stitch-fix/mode-react';
import { AccordionGroup } from '../../../../../components/AccordionGroup';
import type { BrandsValuePageData } from '../../types';
interface FAQsSectionProps {
  data: BrandsValuePageData['faqs'];
}
export const FAQsSection = ({
  data
}: FAQsSectionProps) => {
  return <Box as="section" bgColor="white" py={4}>
      <AccordionGroup {...data} />
    </Box>;
};